import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopPage').create(() => ({
  root: {
    width: '100vw',
    padding: '16px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    paddingBottom: '96px',
  },
  tabsWrapper: {
    width: '100%',
    position: 'fixed',
    padding: '0px 12px',
    left: '0',
    zIndex: '10',
    bottom: 'calc(10vh + 2px)',
  },
}))
